export const SHOW_ALL = 'show_all'
export const SHOW_COMPLETED = 'show_completed'


/** WEBPACK FOOTER **
 ** ./src/constants/TaskFilters.js
 **/